import React, { useState, useEffect } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import _ from 'lodash';
import { Grid, apiClient, TextField, Button, Typography, Box } from "@leap4/frontend";
import {baseSiteUrl} from "../../../config/generals";
import {initialSiteObj, ISite} from "./site.interface";



// Mock API functions
export const fetchSite = async (): Promise<ISite> => {
    const seatData= await apiClient.get(baseSiteUrl);
    if(seatData.data.count===0){
        return initialSiteObj;

    }
    return seatData.data.results[0] as ISite;
};

const updateSeat = async (site: ISite): Promise<ISite> => {
    if (!site._id) {
        const response = await apiClient.post(baseSiteUrl, site);
        return response.data;
    }
    await apiClient.patch(`${baseSiteUrl}/${site._id}`, site);

    return site;
};

const SiteManager: React.FC = () => {
    const queryClient = useQueryClient();
    const { data: siteData, isLoading } = useQuery('site', fetchSite);
    const mutation = useMutation(updateSeat, {
        onSuccess: () => {
             queryClient.invalidateQueries('site');
        },
    });

    const [site, setSite] = useState<ISite>(initialSiteObj);


    useEffect(() => {
        if (siteData) {
            setSite(siteData);
        }
    }, [siteData]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSite({ ...site, [e.target.name]: e.target.value });
    };



    const handleSubmit = () => {
        mutation.mutate(site);
    };

    if (isLoading) return <Typography>Loading...</Typography>;

    return (
        <Box p={5}>
            <Typography variant="h4" gutterBottom>
                 Organization Settings
            </Typography>
            <br/>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TextField
                        label="Name"
                        name="name"
                        value={site.name}
                        onChange={handleChange}
                        sx={{ width: '40%' }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Domain"
                        name="domain"
                        value={site.domain}
                        onChange={handleChange}
                        sx={{ width: '40%' }}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}
                        disabled={mutation.isLoading || _.isEqual(site, siteData)}
                    >
                        {mutation.isLoading ? 'Saving...' : 'Save'}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );


};

export default SiteManager;
